export * from './inventory-addon.page';
